import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import NotFound from "./pages/NotFound";

import ProtectedRoute from "./components/ProtectedRoute"; // admin: utilise isAuthenticated()
import PublicRoute from "./components/PublicRoute";       // admin: utilise isAuthenticated()

import FournisseurLogin from "./pages/FournisseurLogin";
import FournisseurLayout from "./pages/FournisseurLayout";
import FournisseurChangePassword from "./pages/FournisseurChangePassword";
import DashboardFournisseur from "./pages/DashboardFournisseur";

// ✅ nouveaux guards fournisseur
import ProtectedFournisseurRoute from "./components/ProtectedFournisseurRoute";
import PublicFournisseurRoute from "./components/PublicFournisseurRoute";


export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public ADMIN */}
        <Route element={<PublicRoute />}>
          <Route path="/" element={<Login />} />
        </Route>

        {/* Public FOURNISSEUR */}
        <Route element={<PublicFournisseurRoute />}>
          <Route path="/fournisseur/login" element={<FournisseurLogin />} />
        </Route>

        {/* Protected ADMIN */}
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard/*" element={<Dashboard />} />
        </Route>

        {/* Protected FOURNISSEUR */}
        <Route element={<ProtectedFournisseurRoute />}>
          <Route path="/fournisseur/*" element={<FournisseurLayout />}>
            <Route path="change-password" element={<FournisseurChangePassword />} />
            <Route path="dashboard" element={<DashboardFournisseur />} />
          </Route>
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
